@if (showTitle == true) {
  <div>
    <app-page-header title="Aspekttexter" translateTitle="no" icon="notes"></app-page-header>
  </div>
}
<div [ngClass]="aspectId ? '' : 'page-content'">

  @if (!aspectId) {
    <div class="flex-col gap-1em">
      <mat-form-field class="flex-1">
        <mat-label>{{'globalTexts.SearchInstruction' | translate}}</mat-label>
        <input [(value)]="currentSearchText" matInput (keyup)="applyFilter($event.target.value)">
      </mat-form-field>
    </div>
  }

  <div [ngClass]="aspectId ? '' : 'mat-elevation-z8'">
    @if (loadingIndicator) {
      <mat-progress-bar mode="query"></mat-progress-bar>
    }
    <mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="aspectTextId">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Id </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.aspectTextId}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Namn </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.name}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="versionNo">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Version </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.versionNo}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="bedAndBreakfast">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Bed &amp; Breakfast </mat-header-cell>
        <mat-cell *matCellDef="let row"><mat-checkbox [checked]="row.bedAndBreakfast"></mat-checkbox></mat-cell>
      </ng-container>


      <ng-container matColumnDef="gastgiveri">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Gästgiveri </mat-header-cell>
        <mat-cell *matCellDef="let row"><mat-checkbox [checked]="row.gastgiveri"></mat-checkbox></mat-cell>
      </ng-container>


      <ng-container matColumnDef="hotell">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Hotell </mat-header-cell>
        <mat-cell *matCellDef="let row"><mat-checkbox [checked]="row.hotell"></mat-checkbox></mat-cell>
      </ng-container>


      <ng-container matColumnDef="hus">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Hus </mat-header-cell>
        <mat-cell *matCellDef="let row"><mat-checkbox [checked]="row.hus"></mat-checkbox></mat-cell>
      </ng-container>


      <ng-container matColumnDef="lagenhet">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Lägenhet </mat-header-cell>
        <mat-cell *matCellDef="let row"><mat-checkbox [checked]="row.lagenhet"></mat-checkbox></mat-cell>
      </ng-container>

      <ng-container matColumnDef="pensionat">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Pensionat </mat-header-cell>
        <mat-cell *matCellDef="let row"><mat-checkbox [checked]="row.pensionat"></mat-checkbox></mat-cell>
      </ng-container>

      <ng-container matColumnDef="restaurang">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Restaurang </mat-header-cell>
        <mat-cell *matCellDef="let row"><mat-checkbox [checked]="row.restaurang"></mat-checkbox></mat-cell>
      </ng-container>

      <ng-container matColumnDef="stuga">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Stuga </mat-header-cell>
        <mat-cell *matCellDef="let row"><mat-checkbox [checked]="row.stuga"></mat-checkbox></mat-cell>
      </ng-container>

      <ng-container matColumnDef="upplevelse">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Upplevelse </mat-header-cell>
        <mat-cell *matCellDef="let row"><mat-checkbox [checked]="row.upplevelse"></mat-checkbox></mat-cell>
      </ng-container>

      <ng-container matColumnDef="vandrarhem">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Vandrarhem </mat-header-cell>
        <mat-cell *matCellDef="let row"><mat-checkbox [checked]="row.vandrarhem"></mat-checkbox></mat-cell>
      </ng-container>

      <ng-container matColumnDef="enabled">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Aktiv </mat-header-cell>
        <mat-cell *matCellDef="let row">{{row.enabled | boolYesNoTranslator }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="createdDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Skapad </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.createdDate | dateFormatter:true }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="updatedDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Ändrad </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.updatedDate | dateFormatter:true }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef class="flex-100px justify-center">
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="flex-100px justify-center">
          <button mat-icon-button matTooltip="{{'commands.Edit' | translate}}"  (click)="showDetails($event, row)">
            <mat-icon>edit</mat-icon>
          </button>
          @if (hasPermissionToDelete()) {
            <button mat-icon-button matTooltip="{{'commands.Delete' | translate}}" (click)="confirmDelete(row)">
              <mat-icon color="warn">delete</mat-icon>
            </button>
          }
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;">
      </mat-row>
    </mat-table>

    @if (!aspectId) {
      <mat-paginator hidePageSize="true" pageSize="15" [pageSizeOptions]="[5, 10, 25, 100]" class="customPaginator"></mat-paginator>
    }

    @if (hasPermissionToChange()) {
      <section class="button-container">
        <button mat-fab color="primary" matTooltip="{{'commands.Add' | translate}}" (click)="showDetails($event, null)"><mat-icon>add</mat-icon></button>
      </section>
    }

  </div>
</div>
